import React from "react";
import type {MatchDisplay} from '@iziping/common';
import {useTranslation} from "react-i18next";

interface BracketRoundProps {
    matches: MatchDisplay[];
}

const BracketRound: React.FC<BracketRoundProps> = ({matches}) => {
    const {t} = useTranslation();

    return (
        <div className={'content'}>
            <main>
                <ul className="round">
                    <li className="spacer">&nbsp;</li>
                    <li className="title">Tour 1</li>
                </ul>
            </main>
            <main id="content">
                <ul className="round">
                    {matches?.map((match: MatchDisplay) => (
                        <div>
                            <li className='spacer'>&nbsp;</li>
                            <li className='game game-top'>{`${match.opponents && match.opponents[0].ranking} ${(match.opponents && match.opponents[0].name) || t('heat.bracket.bye')}`}</li>
                            <li className='game game-spacer'>&nbsp;</li>
                            <li className='game game-bottom'>{`${(match.opponents && match.opponents.length > 1) ? match.opponents[1].ranking + ' ' + match.opponents[1].name : t('heat.bracket.bye')}`}</li>
                        </div>
                    ))}
                </ul>
            </main>
        </div>
    )
}

export default BracketRound;